var map = {
	"./bond/marque.svg": 43860,
	"./breathspec-covid01/marque.svg": 60960,
	"./inteliswab/marque.svg": 69448,
	"./luas/marque.svg": 7888,
	"./merck/marque.svg": 45993,
	"./transform/marque.svg": 96878,
	"./verifi-connect/marque.svg": 24212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80117;